import React from "react";
import { NavLink } from "react-router-dom";
import "../../../css/TopbarHelpDesk.css";

const QueryInboxTopbar: React.FC = () => {
  return (
    <nav className="admin-center-topbar">
      <NavLink
        to="/helpdesk"
        className={({ isActive }) => (isActive ? "admin-center-tab active" : "admin-center-tab")}
      >
        Query Inbox
      </NavLink>
    </nav>
  );
};

export default QueryInboxTopbar;

